module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"calendarWeek":"Calendar week {0}"},"de":{"calendarWeek":"Kalenderwoche {0}"},"fr":{"calendarWeek":"Semaine Civile {0}"},"it":{"calendarWeek":"Settimana di Calendario {0}"}}')
  delete Component.options._Ctor
}
